'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var debug = require('debug');
var block = require('multiformats/block');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

const log = debug__default["default"]('ipfs:repo:utils:walk-dag');
async function* walkDag(cid, blockstore, loadCodec, options) {
  try {
    const bytes = await blockstore.get(cid, options);
    const codec = await loadCodec(cid.code);
    const block$1 = block.createUnsafe({
      bytes,
      cid,
      codec
    });
    for (const [, childCid] of block$1.links()) {
      yield childCid;
      yield* walkDag(childCid, blockstore, loadCodec, options);
    }
  } catch (err) {
    log('Could not walk DAG for CID', cid.toString(), err);
    throw err;
  }
}

exports.walkDag = walkDag;
